/* istanbul ignore file */
import { SectionRow } from 'framework/ui/layout';
import { BooleanField, CapitalizedField, TextField } from 'framework/ui/field';
import { EmployeeOfficeField, ContractTypeField } from 'domain/shared/employee';

interface OfferCompensationDetailsFieldProps {
  value?: {
    baseAmountType?: string;
    currency?: string;
    calculatedGrossAmount?: string;
    grossAmount?: string;
    grossProbationAmount?: string;
    officeId?: string;
    contractType?: string;
    isAccepted?: boolean;
  };
  canViewBaseFinanceFields?: boolean;
  canViewCalculatedGrossField?: boolean;
  canViewProbationField?: boolean;
}

const OfferCompensationDetailsField = ({
  value,
  canViewBaseFinanceFields = true,
  canViewCalculatedGrossField = true,
  canViewProbationField = true,
}: OfferCompensationDetailsFieldProps) => {
  return (
    <SectionRow>
      <CapitalizedField value={value?.baseAmountType} label="Base amount type" isVisible={canViewBaseFinanceFields} />
      <TextField value={value?.currency} label="Currency" isVisible={canViewBaseFinanceFields} />
      <TextField value={value?.grossAmount} label="Final amount gross" isVisible={canViewBaseFinanceFields} />
      <TextField
        value={value?.calculatedGrossAmount}
        label="Calculated amount gross"
        isVisible={canViewCalculatedGrossField}
      />
      <TextField value={value?.grossProbationAmount} label="Probation amount gross" isVisible={canViewProbationField} />
      <EmployeeOfficeField value={value?.officeId} label="Office" />
      <ContractTypeField value={value?.contractType} label="Contract type" />
      <BooleanField value={value?.isAccepted} label="Compensation accepted" />
    </SectionRow>
  );
};

export default OfferCompensationDetailsField;
